export enum TAG_TYPE {
  DEFAULT = "default",
  SUCCESS = "success",
  WARNING = "warning",
  ERROR = "error",
  INFO = "info",
  WAITING = "waiting",
}
